
import { defineComponent } from "@vue/runtime-core";
import authFooter from "@/modules/auth/components/authFooterComponent.vue"
import ResponseData from "../../../_models/ResponseData"
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
;
import { Helper } from "@/utils/Helper";

export default defineComponent({
  name: "viewAuthVerifySignup",
  components:{
    authFooter
  },
  data() {
    return {
      activeSection: "verifyUser",
    }
  },
  methods: {
    verifyUser() {
      this.activeSection = 'loadingVerifyUser';
      let verifyToken = this.$route.query.token!.toString();

      XarcadeAccountService.verifyRegistration(verifyToken)
        .then((response: ResponseData) => {
          if (response.status === 200) {
            this.activeSection = 'verifyUserSuccess';
            createToast(
            {
              title: "Yay!",
              description: response.data['message'] ? response.data['message'] : response.data,
            },
            {
              position: "bottom-right",
              type: "success",
            }
          );
          } else {
            this.activeSection = 'verifyUser';
            createToast(
            {
              title: "Oops",
              description: response.data['message'] ? response.data['message'] : response.data,
            },
            {
              position: "bottom-right",
              type: "warning",
            });
          }
        }).catch((error) => {
          this.activeSection = 'verifyUser'
          Helper.endpointErrorHandling(error);
        });
    }
  }
});
